import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/app/Bits";
import { StateScreen, StateButton } from "@/components/app/AppStates";

export default function VerifyEmail() {
  const nav = useNavigate();
  const { session, reload } = useAuth();
  const [res, setRes] = useState(null);
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    window.history.replaceState(null, "", "/verify-email");
    if (!token) { setRes({ ok: false, text: "This confirmation link is incomplete." }); return; }
    api.post("/auth/verify-email", { token }).then(() => { setRes({ ok: true }); reload(); })
      .catch((e) => setRes({ ok: false, text: errMsg(e) }));
  }, [reload]);
  if (!res) return <div className="min-h-screen flex items-center justify-center" data-testid="verify-email-loading"><Loading label="Confirming your email…" /></div>;
  const next = session ? "/app/dashboard" : "/login";
  return res.ok
    ? <StateScreen kind="setup" testid="verify-email-ok" title="Email confirmed" text="Thanks — your email address is confirmed."
        actions={<StateButton primary onClick={() => nav(next, { replace: true })} data-testid="verify-email-continue">Continue</StateButton>} />
    : <StateScreen kind="expired" testid="verify-email-error" title="We couldn't confirm your email" text={res.text}
        actions={<StateButton primary onClick={() => nav(next, { replace: true })} data-testid="verify-email-back">{session ? "Back to 86'd" : "Sign in"}</StateButton>} />;
}

export function VerifyBanner() {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);
  if (user?.email_verified !== false) return null;
  const resend = async () => {
    try { await api.post("/auth/verify-email/resend"); setSent(true); } catch (e) { setSent(errMsg(e)); }
  };
  return (
    <div className="no-print mb-5 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 flex flex-wrap items-center gap-x-3 gap-y-1" role="status" data-testid="verify-banner">
      <span>Confirm your email ({user.email}) so account and security notices reach you.</span>
      {sent ? <span className="text-xs" data-testid="verify-banner-sent">{sent === true ? "Link sent — check your inbox." : sent}</span>
        : <button type="button" onClick={resend} className="underline font-medium" data-testid="verify-banner-resend">Send link again</button>}
    </div>
  );
}
